import BoxListTable from './boxListTable.container'

export default BoxListTable